import { useState, useCallback, useRef } from 'react';

const ERROR_THRESHOLD = 3;
const ERROR_WINDOW_MS = 30_000;

export const useLayerErrorTracker = () => {
  const [errors, setErrors] = useState<Record<string, boolean>>({});
  const errorCounts = useRef<Record<string, { count: number; firstAt: number }>>({});

  const reportTileError = useCallback((layerKey: string) => {
    const now = Date.now();
    const entry = errorCounts.current[layerKey];

    if (!entry || now - entry.firstAt > ERROR_WINDOW_MS) {
      errorCounts.current[layerKey] = { count: 1, firstAt: now };
    } else {
      entry.count++;
    }

    if ((errorCounts.current[layerKey]?.count ?? 0) >= ERROR_THRESHOLD) {
      setErrors(prev => prev[layerKey] ? prev : { ...prev, [layerKey]: true });
    }
  }, []);

  const clearError = useCallback((layerKey: string) => {
    delete errorCounts.current[layerKey];
    setErrors(prev => {
      if (!prev[layerKey]) return prev;
      const next = { ...prev };
      delete next[layerKey];
      return next;
    });
  }, []);

  return { tileErrors: errors, reportTileError, clearError };
};
